<div [ngClass]="{'login-wrap': loginService.isLoginComponent, 
'main-grid': loginService.activatedNavigationComponent, 
'main-wrap': !loginService.activatedNavigationComponent}">
    <div class="header-wrap" *ngIf="loginService.activatedNavigationComponent">
        <p-toast></p-toast>
        <app-user-info></app-user-info>
    </div>

    <div class="sidenav-wrap" *ngIf="loginService.activatedNavigationComponent">
        <app-navigation></app-navigation>
    </div>

    <div [ngClass]="{
'router-wrap-connected': loginService.activatedNavigationComponent, 
'router-wrap-not-connected': !loginService.activatedNavigationComponent}">
        <router-outlet></router-outlet>
    </div>
</div>